import React, { Dispatch, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import AnnouncementIcon from '../../common/components/AnnouncementIcon';
import { Markup } from 'interweave';
import './Announcements.css'
import { Grid, Link } from '@material-ui/core';
import NotificationIcon from '../../common/components/NotificationIcon';
import FullscreenLoader from '../../common/components/FullscreenLoader';
import { sendAnnouncmentToCustomer } from "../../store/actions/announcements.actions";

const AnnouncementDetail: React.FC = () => {
    const announcementDetail: any = useSelector((state: any) => state.announcements);
    const dispatch: Dispatch<any> = useDispatch();
    const contentRef = useRef<HTMLDivElement>(null);

    if (announcementDetail?.announcementDetail?.data
    ) {
        localStorage.setItem("announcementTitle", announcementDetail.announcementDetail.data.title)
        localStorage.setItem("announcementArticleBody", announcementDetail.announcementDetail.data.Article_Body)
        localStorage.setItem("announcementImage", announcementDetail.announcementDetail.data.HeroImage.renditionList[0].resourceUri)
    }

    const userType: any = sessionStorage.getItem('userType');

    const hasDetails = announcementDetail?.announcementDetail?.data && !announcementDetail.loading;

    useEffect(() => {
        if (!contentRef.current) return;

        const tables = contentRef.current.querySelectorAll('table');

        tables.forEach((table) => {
            const rows = Array.from(table.querySelectorAll('tr'));
            if (rows.length === 0) return;

            const getColCount = (row: Element) => {
                let count = 0;
                row.querySelectorAll('td, th').forEach((cell) => {
                    const colspan = parseInt(cell.getAttribute('colspan') || '1', 10);
                    count += isNaN(colspan) ? 1 : colspan;
                });
                return count;
            };

            let maxCols = 0;
            rows.forEach((row) => {
                const count = getColCount(row);
                if (count > maxCols) maxCols = count;
            });

            rows.forEach((row) => {
                const missing = maxCols - getColCount(row);
                for (let i = 0; i < missing; i++) {
                    const emptyTd = document.createElement('td');
                    emptyTd.innerHTML = '&nbsp;';
                    row.appendChild(emptyTd);
                }
            });
        });
    }, [announcementDetail?.announcementDetail?.data]);


    
    return (
        <>
            {announcementDetail?.loading && <FullscreenLoader />}
            <div className="row mb-4">
                <div className="col-8">
                    <h2 className="page-title ml-2">Announcement</h2>
                </div>
                <div className="col-4">
                    <div className="notification-pull-right">
                        <AnnouncementIcon />
                        <NotificationIcon />
                    </div>
                </div>
            </div>
            {hasDetails ? (
                <Paper className="height-500 ml-2 pt-3 pl-3">
                    <Grid container spacing={2}>
                        <Grid item xs={8}>
                            <Typography variant="h6" className="announce-sub-title" gutterBottom>
                                {announcementDetail.announcementDetail.data.title}
                            </Typography>

                            <Typography variant="caption" className="announce-date" display="block" gutterBottom>
                                {announcementDetail.announcementDetail.data.date}
                            </Typography>

                            <Typography component="span" variant="body2" className="announce-content mt-4" gutterBottom>
                                <div
                                    ref={contentRef}
                                    className="announce-content"
                                    style={{
                                        display: 'block',
                                        width: '100%',
                                        whiteSpace: 'normal',
                                        wordBreak: 'break-word',
                                        marginTop: '20px',
                                        boxSizing: 'border-box',
                                    }}
                                >
                                    <Markup
                                        content={
                                            announcementDetail.announcementDetail.data.Article_Body || ""
                                        }
                                    />
                                </div>
                            </Typography>
                        </Grid>

                        <Grid item xs={4}>
                            <img
                                className="img-fluid"
                                src={
                                    announcementDetail.announcementDetail.data.HeroImage.renditionList[0]
                                        .resourceUri
                                }
                                alt="Announcement"
                            />
                        </Grid>
                    </Grid>

                    {userType && userType !== 'dealerUser' && (
                        <Link
                            style={{ color: "#4e73df", fontWeight: "bolder" }}
                            onClick={() => {
                                let templateData = {
                                    userType: "KAM",
                                    emailType: "Announcements",
                                    webApplicationLoginId: sessionStorage.getItem('webApplicationLoginId'),
                                    announcementDetails: {
                                        name: announcementDetail.announcementDetail.data.name,
                                        parameters: {
                                            SRV: "Page",
                                            "WCM_Page.ResetAll": "TRUE",
                                            presentationtemplate: "onestop_Shared/PT_ArticleDetail",
                                            subtype: "json",
                                        },
                                    },
                                };
                                dispatch(sendAnnouncmentToCustomer(templateData));
                            }}
                        >
                            Send to customer
                        </Link>
                    )}
                </Paper>
            ) : (
                !announcementDetail?.loading && (
                    <div className="img-height-full">
                        <img
                            src="/announcementDetail.png"
                            alt="No Announcement Detail"
                            style={{ width: "100%", height: "100vh", overflow: "hidden" }}
                        />
                    </div>
                )
            )}
        </>
    );
};


export default AnnouncementDetail;